export default __webpack_public_path__ + "static/media/PDF_file_icon.2ab410ac.png";